import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Serverurl from './Apiurl';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';

import FormControl from '@mui/material/FormControl';
export default class ResetPassword extends Component {
	constructor(props) {
    super(props);
	this.state = {redirect:false,pagename:'',pnlmsg:false,msgtext:'',errormessage:'',erroropen:false,alerttype:'error',btndisabled:false,btntext:'Submit',
	emailid:'',Password:'',showPassword:false,conshowPassword:false,pnllogin:true}
	
	}
handleChange = event => {
let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 };
 handleErrorclose=(event)=>{
	  
	this.setState({erroropen: false});  
  };

  handleClickShowPassword = () => {
    
	this.setState({
            showPassword: !this.state.showPassword
          })
  };
	handleClickconPassword = () => {
    
	this.setState({
            conshowPassword: !this.state.conshowPassword
          })
  };
componentDidMount() {
	let search = window.location.href;
		
	let UserId = localStorage.getItem("AYEmail");
	if(UserId!==null)
	{
	this.setState({emailid: UserId});
	}
}
getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
OnclickRestPass =(event)=>{
	 event.preventDefault();
let Password = this.state.Password;
let confPassword = this.state.confPassword;
let emailid = this.state.emailid;

 if(Password==="")
{
	this.setState({errormessage:"Please Enter Password",erroropen:true});
		 window.scrollTo({        top: 0     })
	return false;
}else{
	if(Password.length<6)
	{
		this.setState({errormessage:"Please Enter Strong Password.",erroropen:true});
			 window.scrollTo({        top: 0     })
	return false;
	}
}

 if(confPassword!==Password)
{
	this.setState({errormessage:"Please ReType Correct Password",erroropen:true});
	return false;
}
  this.setState({btndisabled:true,btntext:'Processing...',errormessage:'',erroropen:false});
var formData = new FormData();
 
    formData.append('action','customerresetpassword')
	formData.append('cu_emailid',emailid)
	formData.append('cu_password',confPassword)
	axios.post(Serverurl+"ajaxcustomer.php", formData, {
        }).then(res => {
				 window.scrollTo({        top: 0     })
			localStorage.removeItem("AYEmail")
			 this.setState({btndisabled:false,submitbtn:'change',
			  pnllogin:false,
	 msgtext:"Password has been changed succesfully <a href='/Signin'  className='link'>Click here to Login</a>",})
			
		});
}

render(){
		  let msgtext=this.state.msgtext;
	 	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
	  return(
	 <div className="contentseclog-col"> <div className="regform"><h2>Reset Password</h2>
	  <p>  <Collapse in={this.state.erroropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
 <div dangerouslySetInnerHTML={ { __html: msgtext}} className="messagetxt"/>
	  {this.state.pnllogin===true &&(<React.Fragment>
	   <p>
	 	 <FormControl fullWidth variant="outlined" className="signinpt" 	InputLabelProps={{ shrink: false }}>
         
          <OutlinedInput 
             id="Password" name="Password"   value={this.state.Password} placeholder="Password"
            type={this.state.showPassword ? 'text' : 'password'}  onChange={this.handleChange}
		
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                  edge="end"
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
	 </p>
	 <p>
	 	 <FormControl  fullWidth variant="outlined" className="signinpt" >
         
          <OutlinedInput
             id="confPassword" name="confPassword"   value={this.state.confPassword} placeholder="Confirm Password"
            type={this.state.conshowPassword ? 'text' : 'password'}  onChange={this.handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickconPassword}
                  onMouseDown={this.handleMouseDownPassword}
                  edge="end"
                >
                  {this.state.conshowPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
	 </p><p><Button
            type="submit"
            fullWidth
			disabled={this.state.btndisabled}
            variant="contained" 
        className="frmPrimarybtn"
           id="searchform" 
		onClick={this.OnclickRestPass}
           
          >
           {this.state.btntext} 
          </Button>
		  </p></React.Fragment>)}
		  </div></div>
	  )
}
}




